// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3kJn5","brands":"styles_brands__1KhAO","image":"styles_image__2n4di"};